import { render, staticRenderFns } from "./SupplierTransportVehicles.vue?vue&type=template&id=19b55ff1&"
import script from "./SupplierTransportVehicles.vue?vue&type=script&lang=js&"
export * from "./SupplierTransportVehicles.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports